import React from 'react';

import useHpEventCta from '../../../hooks/useHpEventCta';
import { HpEventCtaVariants } from '../constants';

import styles from '../findAccommodations.scss';

const HpDualVariant = ({ surface, event }) => {
    const {
        handleCtaClick,
        handleSearchHotelsClick,
    } = useHpEventCta({ surface, event, variant: HpEventCtaVariants.HP_DUAL });

    return (
        <div
            className={`${styles.hpEventCtaContainer} ${styles.hpDual}`}
        >
            <div
                className={styles.hero}
                data-testid="event-profile.find-accommodations.hp-dual.hero-wrapper"
            >
                <img
                    className={styles.heroImage}
                    src="/img/v3/graphics/perks/global-privileges/find-accommodations-hotel.png"
                    alt="Match Day Ready Hotels, powered by Hotel Planner"
                    data-testid="event-profile.find-accommodations.hp-dual.hero-image"
                />
            </div>
            <p
                className={styles.title}
                data-testid="event-profile.find-accommodations.hp-dual.title"
            >
                Match Day Ready Hotels
            </p>
            <p
                className={styles.subtitle}
                data-testid="event-profile.find-accommodations.hp-dual.subtitle"
            >
                Get match ready without the stress. Book your ideal match retreats with unbeatable prices today.
            </p>
            <button
                type="button"
                className={styles.exploreButton}
                onClick={handleSearchHotelsClick}
                data-testid="event-profile.find-accommodations.hp-dual.search-hotels-btn"
            >
                Explore Hotels
            </button>
            <div
                className={styles.callout}
            >
                <p
                    className={styles.calloutHeading}
                    data-testid="event-profile.find-accommodations.hp-dual.callout-heading"
                >
                    Want to save more?
                </p>
                <p
                    className={styles.calloutBody}
                    data-testid="event-profile.find-accommodations.hp-dual.callout-body"
                >
                    Annual Power members get up to 60% off hotels worldwide, plus $250+ in annual travel benefits.
                </p>
                <button
                    type="button"
                    className={styles.calloutLink}
                    onClick={handleCtaClick}
                    data-testid="event-profile.find-accommodations.hp-dual.unlock-power-rates-link"
                >
                    Unlock Annual Power Rates
                </button>
            </div>
        </div>
    );
};

export default HpDualVariant;
